import React from "react";
import { withRouteData, Link } from "react-static";
import Moment from "react-moment";
import Markdown from "react-markdown";
import styled from "styled-components";
//
const CarWrapper = styled.article`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  > a {
    max-width: 33%;
  }
  @media (max-width: 1100px) {
    > a {
      max-width: 50%;
    }
  }
  @media (max-width: 800px) {
    > a {
      max-width: 100%;
    }
  }
`;
const CarSection = styled.section`
  flex-grow: 1;
  background: lightgrey;
  margin: 0 10px 0 0;
  padding: 1em;
  margin-bottom: 1em;
  cursor: pointer;
  flex-basis: 50%; /* default auto */
  min-height: 550px;
  display: flex;
  flex-direction: column;
  background-position: center;
  background-size: cover;
  color: white;
  z-index: -2;

  > time {
    font-weight: normal;
    font-size: 1em;
    margin-bottom: 0.5em;
    display: block;
  }
  > h2 {
    font-family: derek;
    margin-bottom: 0.5em;
  }
  > p {
    font-weight: normal;
    margin 0.4em 0;
  }
  > img {
    max-height: 200px;
    z-index: 5;
  }

  > .kaufen {
    width: 100%;
    height: 30px;
    cursor: pointer;
    border-radius: 4px;
    font-family: derek;
    font-size: 1em;
    margin-top: auto;
  }
  > .kaufen:hover {
    background-color: black;
    color: white;
  }
  > div {
    width: 100%;
  }
`;

// let cities = data.filter(val => {
//   return val.population > 500000000;
// });

class Fahrzeuge extends React.Component {
  constructor(props) {
    super(props);
    console.log(props);
  }

  render() {
    const { cars } = this.props;
    const filteredcars = cars.filter(function(car) {
      return car.data.avaliable === true;
    });
    return (
      <div>
        <h1>Zu Verkaufen</h1>
        <div>
          <CarWrapper>
            {filteredcars.map(car => (
              <Link to={`/Fahrzeuge/${car.data.slug}`}>
                <CarSection
                  key={car.data.slug}
                  style={{ backgroundImage: `url(${car.data.thumbnail})` }}
                >
                  <h2>{car.data.title}</h2>
                  <Moment format="MMMM Do, YYYY">{car.data.date}</Moment>
                  <div>
                    <img src={car.data.thumbnail} />
                  </div>
                  <p>
                    <strong>Marke: </strong>
                    {car.data.marke}
                  </p>
                  <p>
                    <strong>Modell: </strong>
                    {car.data.model}
                  </p>
                  <p>
                    <strong>Preis: </strong>
                    {car.data.preis}
                  </p>
                  <p>
                    <strong>Model: </strong>
                    {car.data.model}
                  </p>
                  <button className="kaufen">Details</button>
                </CarSection>
              </Link>
            ))}
          </CarWrapper>
        </div>
      </div>
    );
  }
}
export default withRouteData(({ cars }) => <Fahrzeuge cars={cars} />);



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/Fahrzeuge.js